import React, {Fragment, PureComponent} from 'react';

import {connect} from 'react-redux';
import {InputItem, Button, Toast, WingBlank,List} from 'antd-mobile';
import {
    sendMessageActionResult,
    userFindPassword
} from './store/actionCreators';
import './index.scss';
import history from '../../utils/history';
import PublicHeader from './../../components/header/index';


class Forget extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            sendMessage: '获取验证码',
            time: 10,
            sendStatus: 0,
        }
        this.init();
    }

    init() {
        this.bindEvent();
    }

    bindEvent() {
        this.handleSendCode = this.handleSendCode.bind(this);
        this.userFindPassword = this.userFindPassword.bind(this);
    }

    async userFindPassword() {

        let cardNo = this.cardRef.state.value;
        let phone = this.phoneRef.state.value;
        let smsCode = this.validateRef.state.value;
        let newPassword = this.newPasswordRef.state.value;
        let newPassword2 = this.newPasswordRef2.state.value;

        if (!cardNo) {
            Toast.info("请输入会员卡号！")
            return;
        }

        if (!phone) {
            Toast.info("请输入手机号！")
            return;
        }
        if (!newPassword || !newPassword2) {
            Toast.info("请输入密码！")
            return;
        }
        if (!newPassword == newPassword2) {
            Toast.info("两次输入密码不一致！")
            return;
        }

        if (!smsCode) {
            Toast.info("请输入短信验证码！")
            return;
        }

        const data = {
            cardNo: cardNo,
            phone: phone,
            smsCode: smsCode,
            password: newPassword,
        };

        const result = await this.props.userFindPassword(data);

        console.log("result,", result);

        if (result.data.success) {
            Toast.success('密码更新成功', 3, () => {
                window.location.href = `/login`;
            });
        } else {
            Toast.info(result.data.error);
        }

    }

    async handleSendCode() {
        var time = 60;
        var that = this;
        if (this.state.sendStatus === 1) {
            return;
        }

        const data = {
            type: '3',
            smsType: "2",
            phone: this.phoneRef.state.value
        };

        data.phone = data.phone.replace(/\s+/g, "");

        if (!data.phone) {
            Toast.info("请输入手机号码！")
            return;
        }

        const result = await this.props.handleSendCode(data);

        console.log("result", result)
        if (result.status === 200) {
            Toast.success("发送成功");
        } else {
            Toast.fail('网络异常', 1);
        }

        setInterval(function () {
            if (time <= 0) {
                that.setState({
                    sendMessage: '发送验证码',
                })
            }
            else {
                that.setState({
                    sendMessage: time + "s后重新获取",
                    sendStatus: 1
                });
                time--;
            }
        }, 1000);
    }

    render() {
        const {sendMessage} = this.state;

        return (
            <Fragment>
                <PublicHeader title="找回密码"/>
                <WingBlank size="bg">
                    <div className="forget-form">
                        <InputItem
                            clear
                            ref={el => this.cardRef = el}
                            placeholder="会员卡号"
                            maxLength="60"
                        >会员卡号：</InputItem>
                        <InputItem
                            clear
                            ref={el => this.phoneRef = el}
                            placeholder="手机号码"
                            maxLength="11"
                        >手机号：</InputItem>
                        <InputItem
                            clear
                            ref={el => this.newPasswordRef = el}
                            type="password"
                            placeholder="新密码"
                            maxLength="60"

                        >新密码：</InputItem>
                        <InputItem
                            clear
                            ref={el => this.newPasswordRef2 = el}
                            placeholder="确认新密码"
                            maxLength="60"
                            type="password"
                        >确认密码：</InputItem>

                        <InputItem
                            clear
                            ref={el => this.validateRef = el}
                            placeholder="验证码"
                            extra={sendMessage}
                            onExtraClick={this.handleSendCode}>
                            验证码：
                        </InputItem>

                        <Button style={{backgroundColor: "#F5A623", color: "#FFFFFF", margin: "15px"}}
                                onClick={this.userFindPassword}>更新密码</Button>
                    </div>
                </WingBlank>
            </Fragment>
        )
    }
}

const mapStateToProps = (data) => {
};

const mapDispatchToProps = (dispatch) => ({
    handleSendCode: data => dispatch(sendMessageActionResult(data)),
    userFindPassword: data => dispatch(userFindPassword(data)),

});
export default connect(mapStateToProps, mapDispatchToProps)(Forget);